export default "__VITE_ASSET__xF9kJRAM__"